'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _span;
import * as React from 'react';
import PropTypes from 'prop-types';
import { unstable_useForkRef as useForkRef } from '@mui/utils';
import { useSelect } from "../useSelect/index.js";
import { useSlotProps } from "../utils/index.js";
import { Popup } from "../Unstable_Popup/Popup.js";
import { unstable_composeClasses as composeClasses } from "../composeClasses/index.js";
import { getSelectUtilityClass } from "./selectClasses.js";
import { defaultOptionStringifier } from "../useSelect/defaultOptionStringifier.js";
import { useClassNamesOverride } from "../utils/ClassNameConfigurator.js";
import { SelectProvider } from "../useSelect/SelectProvider.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function defaultRenderValue(selectedOptions) {
    if (Array.isArray(selectedOptions)) {
        return /*#__PURE__*/ _jsx(React.Fragment, {
            children: selectedOptions.map(function(o) {
                return o.label;
            }).join(', ')
        });
    }
    var _selectedOptions_label;
    return (_selectedOptions_label = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.label) !== null && _selectedOptions_label !== void 0 ? _selectedOptions_label : null;
}
function useUtilityClasses(ownerState) {
    var active = ownerState.active, disabled = ownerState.disabled, open = ownerState.open, focusVisible = ownerState.focusVisible;
    var slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible',
            active && 'active',
            open && 'expanded'
        ],
        listbox: [
            'listbox',
            disabled && 'disabled'
        ],
        popup: [
            'popup'
        ]
    };
    return composeClasses(slots, useClassNamesOverride(getSelectUtilityClass));
}
/**
 * The foundation for building custom-styled select components.
 *
 * Demos:
 *
 * - [Select](https://mui.com/base-ui/react-select/)
 *
 * API:
 *
 * - [Select API](https://mui.com/base-ui/react-select/components-api/#select)
 */ var Select = /*#__PURE__*/ React.forwardRef(function Select(props, forwardedRef) {
    var areOptionsEqual = props.areOptionsEqual, autoComplete = props.autoComplete, autoFocus = props.autoFocus, children = props.children, defaultValue = props.defaultValue, _props_defaultListboxOpen = props.defaultListboxOpen, defaultListboxOpen = _props_defaultListboxOpen === void 0 ? false : _props_defaultListboxOpen, disabledProp = props.disabled, getSerializedValue = props.getSerializedValue, listboxId = props.listboxId, listboxOpenProp = props.listboxOpen, _props_multiple = props.multiple, multiple = _props_multiple === void 0 ? false : _props_multiple, name = props.name, _props_required = props.required, required = _props_required === void 0 ? false : _props_required, onChange = props.onChange, onListboxOpenChange = props.onListboxOpenChange, _props_getOptionAsString = props.getOptionAsString, getOptionAsString = _props_getOptionAsString === void 0 ? defaultOptionStringifier : _props_getOptionAsString, renderValueProp = props.renderValue, placeholder = props.placeholder, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, valueProp = props.value, other = _object_without_properties(props, [
        "areOptionsEqual",
        "autoComplete",
        "autoFocus",
        "children",
        "defaultValue",
        "defaultListboxOpen",
        "disabled",
        "getSerializedValue",
        "listboxId",
        "listboxOpen",
        "multiple",
        "name",
        "required",
        "onChange",
        "onListboxOpenChange",
        "getOptionAsString",
        "renderValue",
        "placeholder",
        "slotProps",
        "slots",
        "value"
    ]);
    var renderValue = renderValueProp !== null && renderValueProp !== void 0 ? renderValueProp : defaultRenderValue;
    var _React_useState = _sliced_to_array(React.useState(false), 2), buttonDefined = _React_useState[0], setButtonDefined = _React_useState[1];
    var buttonRef = React.useRef(null);
    var listboxRef = React.useRef(null);
    var _slots_root;
    var Button = (_slots_root = slots.root) !== null && _slots_root !== void 0 ? _slots_root : 'button';
    var _slots_listbox;
    var ListboxRoot = (_slots_listbox = slots.listbox) !== null && _slots_listbox !== void 0 ? _slots_listbox : 'ul';
    var _slots_popup;
    var PopupComponent = (_slots_popup = slots.popup) !== null && _slots_popup !== void 0 ? _slots_popup : 'div';
    var handleButtonRefChange = React.useCallback(function(element) {
        setButtonDefined(element != null);
    }, []);
    var handleButtonRef = useForkRef(forwardedRef, buttonRef, handleButtonRefChange);
    React.useEffect(function() {
        if (autoFocus) {
            buttonRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    var _useSelect = useSelect({
        name: name,
        required: required,
        getSerializedValue: getSerializedValue,
        areOptionsEqual: areOptionsEqual,
        buttonRef: handleButtonRef,
        defaultOpen: defaultListboxOpen,
        defaultValue: defaultValue,
        disabled: disabledProp,
        listboxId: listboxId,
        multiple: multiple,
        open: listboxOpenProp,
        onChange: onChange,
        onOpenChange: onListboxOpenChange,
        getOptionAsString: getOptionAsString,
        value: valueProp,
        componentName: 'Select'
    }), buttonActive = _useSelect.buttonActive, buttonFocusVisible = _useSelect.buttonFocusVisible, contextValue = _useSelect.contextValue, disabled = _useSelect.disabled, getButtonProps = _useSelect.getButtonProps, getListboxProps = _useSelect.getListboxProps, getHiddenInputProps = _useSelect.getHiddenInputProps, getOptionMetadata = _useSelect.getOptionMetadata, value = _useSelect.value, open = _useSelect.open;
    var ownerState = _object_spread_props(_object_spread({}, props), {
        active: buttonActive,
        defaultListboxOpen: defaultListboxOpen,
        disabled: disabled,
        focusVisible: buttonFocusVisible,
        open: open,
        multiple: multiple,
        renderValue: renderValue,
        value: value
    });
    var classes = useUtilityClasses(ownerState);
    var buttonProps = useSlotProps({
        elementType: Button,
        getSlotProps: getButtonProps,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        ownerState: ownerState,
        className: classes.root
    });
    var listboxProps = useSlotProps({
        elementType: ListboxRoot,
        getSlotProps: getListboxProps,
        externalSlotProps: slotProps.listbox,
        additionalProps: {
            ref: listboxRef
        },
        ownerState: ownerState,
        className: classes.listbox
    });
    var popupProps = useSlotProps({
        elementType: PopupComponent,
        externalSlotProps: slotProps.popup,
        additionalProps: {
            anchor: buttonRef.current,
            keepMounted: true,
            open: open,
            placement: 'bottom-start',
            role: undefined
        },
        ownerState: ownerState,
        className: classes.popup
    });
    var selectedOptionsMetadata;
    if (multiple) {
        selectedOptionsMetadata = value.map(function(v) {
            return getOptionMetadata(v);
        }).filter(function(o) {
            return o !== undefined;
        });
    } else {
        var _getOptionMetadata;
        selectedOptionsMetadata = (_getOptionMetadata = getOptionMetadata(value)) !== null && _getOptionMetadata !== void 0 ? _getOptionMetadata : null;
    }
    var _renderValue, _ref;
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({}, buttonProps), {
                children: (_ref = (_renderValue = renderValue(selectedOptionsMetadata)) !== null && _renderValue !== void 0 ? _renderValue : placeholder) !== null && _ref !== void 0 ? _ref : // from https://github.com/mui/material-ui/pull/24563
                _span || (_span = /*#__PURE__*/ _jsx("span", {
                    className: "notranslate",
                    "aria-hidden": true,
                    children: "\u200B"
                }))
            })),
            buttonDefined && /*#__PURE__*/ _jsx(Popup, _object_spread_props(_object_spread({
                slots: {
                    root: PopupComponent
                }
            }, popupProps), {
                children: /*#__PURE__*/ _jsx(ListboxRoot, _object_spread_props(_object_spread({}, listboxProps), {
                    children: /*#__PURE__*/ _jsx(SelectProvider, {
                        value: contextValue,
                        children: children
                    })
                }))
            })),
            /*#__PURE__*/ _jsx("input", _object_spread_props(_object_spread({}, getHiddenInputProps()), {
                autoComplete: autoComplete
            }))
        ]
    });
});
process.env.NODE_ENV !== "production" ? Select.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * A function used to determine if two options' values are equal.
   * By default, reference equality is used.
   *
   * There is a performance impact when using the `areOptionsEqual` prop (proportional to the number of options).
   * Therefore, it's recommented to use the default reference equality comparison whenever possible.
   */ areOptionsEqual: PropTypes.func,
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: PropTypes.string,
    /**
   * If `true`, the select element is focused during the first mount
   * @default false
   */ autoFocus: PropTypes.bool,
    /**
   * @ignore
   */ children: PropTypes.node,
    /**
   * @ignore
   */ className: PropTypes.string,
    /**
   * If `true`, the select will be initially open.
   * @default false
   */ defaultListboxOpen: PropTypes.bool,
    /**
   * The default selected value. Use when the component is not controlled.
   */ defaultValue: PropTypes.any,
    /**
   * If `true`, the select is disabled.
   * @default false
   */ disabled: PropTypes.bool,
    /**
   * A function used to convert the option label to a string.
   * It's useful when labels are elements and need to be converted to plain text
   * to enable navigation using character keys on a keyboard.
   *
   * @default defaultOptionStringifier
   */ getOptionAsString: PropTypes.func,
    /**
   * A function to convert the currently selected value to a string.
   * Used to set a value of a hidden input associated with the select,
   * so that the selected value can be posted with a form.
   */ getSerializedValue: PropTypes.func,
    /**
   * `id` attribute of the listbox element.
   */ listboxId: PropTypes.string,
    /**
   * Controls the open state of the select's listbox.
   * @default undefined
   */ listboxOpen: PropTypes.bool,
    /**
   * If `true`, selecting multiple values is allowed.
   * This affects the type of the `value`, `defaultValue`, and `onChange` props.
   *
   * @default false
   */ multiple: PropTypes.bool,
    /**
   * Name of the element. For example used by the server to identify the fields in form submits.
   */ name: PropTypes.string,
    /**
   * Callback fired when an option is selected.
   */ onChange: PropTypes.func,
    /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see listboxOpen).
   */ onListboxOpenChange: PropTypes.func,
    /**
   * Text to show when there is no selected value.
   */ placeholder: PropTypes.node,
    /**
   * Function that customizes the rendering of the selected value.
   */ renderValue: PropTypes.func,
    /**
   * If `true`, the Select cannot be empty when submitting form.
   * @default false
   */ required: PropTypes.bool,
    /**
   * The props used for each slot inside the Input.
   * @default {}
   */ slotProps: PropTypes /* @typescript-to-proptypes-ignore */ .shape({
        listbox: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object
        ]),
        popup: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object
        ]),
        root: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object
        ])
    }),
    /**
   * The components used for each slot inside the Select.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: PropTypes /* @typescript-to-proptypes-ignore */ .shape({
        listbox: PropTypes.elementType,
        popup: PropTypes.elementType,
        root: PropTypes.elementType
    }),
    /**
   * The selected value.
   * Set to `null` to deselect all options.
   */ value: PropTypes.any
} : void 0;
export { Select };
